
  import { defineComponent, ref, computed, watch } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';
  import { reinitializeComponents } from '@/core/plugins/keenthemes';

  export default defineComponent({
    name: 'property-categories-filter',
    emit: ['property-categories-selected', 'reset'],
    components: {},
    async setup(props, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();
      const selectedItems = ref<any>({
        adTypeId: '',
      });

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const onSubmit = () => {
        emit('property-categories-selected', selectedItems);
      };
      const onReset = () => {
        selectedItems.value = {
          adTypeId: '',
        };
        emit('reset', selectedItems.value);
      };

      await store.dispatch(Actions.GET_ALL_AD_TYPES);

      reinitializeComponents();

      return {
        adTypes: computed(() => store.getters.adTypesAllList),
        onSubmit,
        onReset,
        translate,
        selectedItems,
      };
    },
  });
